import { useCookies } from '@fans-fund-me/shared-common-esm-cookies';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Outlet, useLocation } from 'react-router';

export const Base = () => {
  const cookies = useCookies();
  const location = useLocation();
  const { pathname } = useLocation();

  useEffect(() => {
    if (cookies.permissions === 'all') {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
      });
    }
  }, [location, cookies.permissions]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <Outlet />;
};
